// `video.caption`: captions burned into a video, live's `AUTO_CAPTION` (spec G14-templates, "The
// steps"), the worker's own ffmpeg. Live lists no such job; a template's run starts it.
import { VideoCaptionQuote, VideoCaptionRequest } from "../../../api/generated/zod";
import type { JobTypeModule } from "./contract";

export const jobType: JobTypeModule<"video.caption"> = {
  type: "video.caption",
  label: "Captions",
  source: "form",
  pair: "video.caption",
  fields: () => ({}),
  request: VideoCaptionRequest,
  quote: VideoCaptionQuote,
};
